export function buildHomeworkTestPayload({
  appId,
  appToken,
  appVersion = "1",
  quizData,
  questions
}) {

  const formattedQuestions = questions.map((q, index) => ({

    number: index + 1,

    question: q.question,
    questionInstructions: q.questionInstructions || "",

    options: q.options || [],

    correctOptionIndex: q.correctOptionIndex,

    questionType: q.questionType || "MCQ",

    marks: q.marks || 1,
    negativeMarks: q.negativeMarks || 0,

    difficulty: q.difficulty || "Easy",

    responseSpeed: q.responseSpeed || 30,

    sectionName: q.sectionName || "General",

    relatedTopics: q.relatedTopics || [],

    explanation: q.explanation || "",

    aiVerifiedAnswerExplanation: false,
    confidenceScore: null,
    answerConfidenceReason: "",
    aiNotes: "",
    conceptTags: [],
    questionSourceType: "Homework",

    hint: "",
    commonMistake: ""

  }));

  return {

    appId,

    quizData,

    folderRelation: {},

    appToken,
    appVersion,

    questions: formattedQuestions

  };

}